<template>
  <button class="primary_button" :class="colorType" @click.prevent="onClick">
    <slot></slot>
  </button>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

const colorTypes: { [k: string]: string } = {
  blue: 'blue',
  white: 'white',
}

@Component
export default class PrimaryButton extends Vue {
  @Prop({ default: 'blue' })
  color!: string

  @Emit('click')
  onClick() {}

  get colorType() {
    return colorTypes[this.color] || 'blue'
  }
}
</script>

<style scoped>
.primary_button {
  width: 100%;
  height: 44px;
  border-radius: 22px;
  padding: 11px 16px;
  text-align: center;
  font-size: 14px;
  line-height: 22px;
  font-weight: bold;
}

.-ru .primary_button {
  font-size: 10px;
  letter-spacing: inherit;
}

.primary_button:disabled {
  opacity: 0.38;
}

.blue {
  background-color: #188dff;
  color: #ffffff;
  border: none;
}

.white {
  background-color: #f2f2f2;
  color: #0f0f0f;
  border: none;
}
</style>
